export const sfxList = [
  {
    name: 'zoom',
    url: 'https://qa-dev-quickads-project.quickads.ai/image_projects/94718394-8ef1-4da2-99de-333967f9fbde/assets/audio/0a484492-5846-47a3-b2e7-633baa360031/audio.mp3',
    duration: 0.8
  },
  {
    name: 'Riser',
    url: 'https://project-quickads.quickads.ai/image_projects/3cb7e03d-a95c-4102-86b8-20c5bc8630ed/assets/audio/db9eb2f7-60db-414a-ac31-5e0c0484e44c/audio.mp3',
    duration: 1.5
  },
  {
    name: 'Beat Drop',
    url: 'https://project-quickads.quickads.ai/image_projects/3cb7e03d-a95c-4102-86b8-20c5bc8630ed/assets/audio/1b1bb86e-bacd-481f-9b75-f7520d5a5916/audio.mp3',
    duration: 3.0
  },
  {
    name: 'Joyfull',
    url: 'https://project-quickads.quickads.ai/image_projects/3cb7e03d-a95c-4102-86b8-20c5bc8630ed/assets/audio/596d4f0d-8c6f-4122-814c-99f4ce40f9b1/audio.mp3',
    duration: 3.0
  },
  {
    name: 'Point',
    url: 'https://project-quickads.quickads.ai/image_projects/3cb7e03d-a95c-4102-86b8-20c5bc8630ed/assets/audio/845eedee-b2d7-4d33-be1e-00301e9e860d/audio.mp3',
    duration: 1.0
  }
];

export type SFX = {
  name: string;
  url: string;
  duration: number;
};
   